import { revalidateLogic, useForm } from '@tanstack/react-form'
import { DEFAULT_NOTA_CREDITO_PARCIAL, notaCreditoParcialSchema, type NotaCreditoParcialFormValues } from './notaCreditoParcialSchema'
import { erroresPorCampo } from './useFacturaManualForm'

interface UseNotaCreditoParcialFormOptions {
  /** Lo que queda por acreditar en la factura. El servidor vuelve a validarlo con la factura bloqueada. */
  saldo: number
  onSubmit: (values: NotaCreditoParcialFormValues) => void | Promise<void>
}

export function useNotaCreditoParcialForm({ saldo, onSubmit }: UseNotaCreditoParcialFormOptions) {
  const form = useForm({
    defaultValues: DEFAULT_NOTA_CREDITO_PARCIAL,
    validationLogic: revalidateLogic(),
    validators: {
      onDynamic: ({ value }) => {
        const result = notaCreditoParcialSchema(saldo).safeParse(value)
        if (result.success) return undefined
        return { fields: erroresPorCampo(result.error.issues) }
      },
    },
    onSubmit: async ({ value }) => {
      await onSubmit(value)
    },
  })
  return { form }
}
